import React from 'react'

export const TelehealthIcon = ({
  width = 16,
  height = 16
}: {
  width?: number
  height?: number
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="5" width="14" height="14" rx="2" fill="#A7B4E0" />
    <polygon points="18,10 22,8 22,16 18,14" fill="#A7B4E0" />
  </svg>
)
